import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {IOrderHistoryView, IOrderHistoryViewProduct, IOrderViewPackage, IOrderViewPackslip} from '../orders-models';
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";
import * as _ from "lodash";
import {OrderHistoryCacheService} from "../order-history/order-history-cache.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'order-history-summary',
    templateUrl: './order-history-summary.component.html',
    styleUrls: ['../orders.scss', './order-history-summary.component.scss'],
    standalone: false
})
export class OrderHistorySummaryComponent extends BaseComponent implements OnInit, OnDestroy {
	@Input() orderView: IOrderHistoryView;
	@Input() canAutoOrder: boolean;
    @Input() displayVolume: boolean = false;
    @Input() trackingCount: number = 0;
	@Output() readonly addFullOrder = new EventEmitter<IOrderHistoryViewProduct[]>();
	@Output() readonly viewTracking = new EventEmitter<IOrderHistoryView>();

    trackingNumber: string;
    trackingLink: string;
    isAddingToCart: boolean = false;
    subscription: Subscription = new Subscription();

	constructor(
        private userService: UserService,
        private loggerService: LoggerService,
        private orderHistoryCacheService: OrderHistoryCacheService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        // any single item is being added to cart for this order OR if the full order is being added to cart
        this.subscription.add(this.orderHistoryCacheService.productsAddingSubject.subscribe((productsAddingMap) => {
            this.isAddingToCart = productsAddingMap?.get(this.orderView.id)?.length > 0;
        }));
        this.subscription.add(this.orderHistoryCacheService.orderAddingSubject.subscribe((orderId) => {
            this.isAddingToCart = orderId === this.orderView.id;
        }));

        if (this.trackingCount == 1) {
            this.setTrackingNumber();
            this.setTrackingLink();
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    get canAddToCart(): boolean {
        return !!_.find(this.orderView?.products, (product: IOrderHistoryViewProduct) => product?.canAddToCart);
    }

    setTrackingNumber() {
        // get first packslip package that has a tracking number
        const packslip: IOrderViewPackslip = _.find(this.orderView?.packslips, (packslip: IOrderViewPackslip) =>
            !!_.find(packslip?.packages, 'trackingNumber')
        );
        const pkg: IOrderViewPackage = _.find(packslip?.packages, 'trackingNumber');
        this.trackingNumber = pkg?.trackingNumber;
    }

    setTrackingLink() {
        // get first packslip package that has a tracking link
        const packslip: IOrderViewPackslip = _.find(this.orderView?.packslips, (packslip: IOrderViewPackslip) =>
            !!_.find(packslip?.packages, 'trackingLink')
        );
        const pkg: IOrderViewPackage = _.find(packslip?.packages, 'trackingLink');
        this.trackingLink = pkg?.trackingLink;
    }

	openOrderTrackingModal(orderView: IOrderHistoryView) {
		this.viewTracking.emit(orderView);
	}
}
